export default __webpack_public_path__ + "static/media/fond-arrondi-blanc-droite.5089cc2b.webp";